module.exports = __webpack_public_path__ + "static/img/floor1-img.926adc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-img.png
// module id = dSpR
// module chunks = 1